import { Model } from 'backbone';
import _ from 'lodash';
import { User } from '../../../core/models';
import Radio from 'backbone.radio';
import { isAuthorized, Secret } from '../../../core/utils';

const
	leagueChannel = Radio.channel( 'league' ),
	menuChannel   = Radio.channel( 'menu' );
const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON || 'false');

export class CoreMenuModel extends Model {

	defaults() {
		return {
			current_menu: {}
		};
	}

	initialize() {
		this.id              = 0;
		this.is_commissioner = false;
		this.is_supported    = false;
		this.is_authorized   = false;
		this.menu_items      = {};
		this.initListeners();
	}

	initListeners() {
		this.listenTo( leagueChannel, 'league:query:response', this.checkIsShowLeagueMenuItem );
	}

	setMenu( options ) {
		this.set(this.defaults());
		this.checkIsAutorized();
		let menu_items = this.menu_items,
			menu       = this.updateMenu( menu_items, options );
		this.set( {
			'menu_items':    this.menu_items,
			'current_menu':  menu,
			'is_authorized': this.is_authorized,
		} );

		return this;
	}

	checkIsAutorized() {
		let menu_items = {};
		if (IS_PRE_SEASON && this.get('menu_for_off_season')) {
			menu_items = this.get( 'menu_for_off_season' );
			this.is_authorized = false;
		}
		else if ( isAuthorized() ) {
			menu_items         = this.get( 'menu_for_authorized_users' );
			this.is_authorized = true;
		}
		else {
			menu_items         = this.get( 'menu_for_not_authorized_users' );
			this.is_authorized = false;
		}

		this.menu_items = menu_items;

	}

	updateMenu( menu_items, options ) {
		this.id  = (options.args) ? options.args[ 0 ] : 0;
		let menu = this.updateMenuIds( menu_items[ options.menu_item ], this.id ),
			name = options.name;

		menu = this.clearActiveMenuItems( menu );
		menu = this.setActiveItems( menu, name );
		const is_off_season_home_route = location.pathname.includes('off-season');
		if (IS_PRE_SEASON && this.get('menu_for_off_season') && is_off_season_home_route) {
			return {};
		}
		return menu;
	}

	setActiveItems( menu, name ) {
		let sub_menus_list      = _.result(menu, 'sub_menus_list', {}),
			extra_menus_list    = _.result(menu, 'extra_menus_list', {}),
			item_key_sub_menu   = _.findKey( sub_menus_list, {
				'method_name': name
			} ),
			item_key_extra_menu = _.findKey( extra_menus_list, {
				'method_name': name
			} );
		if( !item_key_extra_menu ) {
			item_key_extra_menu = _.findKey( extra_menus_list, {
				'extra_method': name
			} );
		}

		if ( item_key_sub_menu && menu.sub_menus_list[ item_key_sub_menu ] ) {
			menu.sub_menus_list[ item_key_sub_menu ].active = true;
			this.set( 'show_extra_menu', false );
		}
		else if ( item_key_extra_menu && menu.extra_menus_list[ item_key_extra_menu ] ) {

			menu.extra_menus_list[ item_key_extra_menu ].active = true;
			menu.extra_menus_list = this.updateMenuIds( menu.extra_menus_list );
			this.set( 'show_extra_menu', true );
		}
		// else if( menu && menu.sub_menus_list[0] ){
		//
		// 	_.each( menu.sub_menus_list, ( item, key )=> {
		// 		// Default set first item active
		// 		let is_active = ( key === 0 );
		// 		menu.sub_menus_list[key].active = is_active;
		// 	});
		// }

		return menu;
	}

	clearActiveMenuItems( menu ) {

		if( menu && menu.sub_menus_list ) {
			_.each( menu.sub_menus_list, ( item, key )=> {
				menu.sub_menus_list[key].active = false;
			});
		}

		if( menu && menu.extra_menus_list ) {
			_.each( menu.extra_menus_list, ( item, key )=> {
				menu.extra_menus_list[key].active = false;
			});
		}

		return menu;
	}

	updateMenuIds( menu ) {
		if (
			!_.isUndefined( menu ) &&
			menu.length > 0
		) {
			menu = menu.filter( item => {
				item.path = item.path.replace( ':id', this.id );
				return item;
			} );
		}

		return menu;
	}

	checkIsShowLeagueMenuItem( response ) {
		this.id = response.id;
		this.checkIsAutorized();
		this.is_commissioner = this.checkIsCommissioner( response );
		this.is_supported    = this.checkIsSupported( response );
		this.is_open         = this.checkIsOpen( response );
		this.is_head_to_head = this.checkIsHeadToHead( response );
		this.checkLeagueMenuItems();

		menuChannel.trigger( 'update:menu' );
	}

	checkIsCommissioner( response ) {
		let commissioner_id = (response.commissioner) ? response.commissioner : 0,
			user_id         = User.id;

		return commissioner_id === user_id;
	}

	checkIsSupported( response ) {
		return response.class === 'club';
	}

	checkIsOpen( response ) {
		return response.privacy === 1;
	}

	checkIsHeadToHead( response ) {
		return response.type === 'head_to_head';
	}

	checkLeagueMenuItems() {
		let current_menu = this.get( 'current_menu' );

		if( current_menu && current_menu.extra_menus_list ) {
			_.each( current_menu.extra_menus_list, ( menu_data, key ) => {
				let data = {
					menu_data,
					key
				};

				menu_data.is_visible = true;

				data = this.checkByCommissioner( data );
				data = this.checkBySupportedTeam( data );
				data = this.checkByType( data );

				current_menu.extra_menus_list[ data.key ] = data.menu_data;
			} );

			//current_menu.extra_menus_list = this.updateMenuIds( current_menu.extra_menus_list );

			this.set( 'current_menu', current_menu );
		}

		return this;
	}

	checkByCommissioner( data ) {
		if ( data.menu_data.check_by_commissioner ) {
			data.menu_data.is_visible = this.is_commissioner || this.is_open;
		}

		return data;
	}

	checkByType( data ) {

		if ( data.menu_data.only_head_to_head ) {
			data.menu_data.is_visible = this.is_head_to_head;
		}
		return data;
	}

	checkBySupportedTeam( data ) {
		if ( data.menu_data.check_by_supported_team && this.is_supported ) {
			data.menu_data.is_visible = false;
		}

		return data;
	}

}

export default CoreMenuModel;